import { useSyncExternalStore } from "react"

const subscribe = (onStoreChange: () => void): (() => void) => {
	const root = document.documentElement
	const observer = new MutationObserver(onStoreChange)
	observer.observe(root, { attributes: true, attributeFilter: ["class"] })
	return () => observer.disconnect()
}

const getSnapshot = (): boolean =>
	document.documentElement.classList.contains("dark")

const getServerSnapshot = (): boolean => false

export const useIsDarkMode = (): boolean =>
	useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)

export const useReportingBarHoverCursor = (): { fill: string } => {
	const isDark = useIsDarkMode()
	return {
		fill: isDark ? "rgba(255, 255, 255, 0.06)" : "rgba(0, 0, 0, 0.04)",
	}
}
